import * as React from 'react';
import AddressFields from './address_fields';

class BillingAddressFields extends React.Component {
  render() {
    return (
      <AddressFields
        includePhoneInput={false}
        includeNameInput={false}
        includeSaveButton
        saveButtonText={I18n.t('js.creditCards.creditCardForm.saveCard')}
        addressTitle={I18n.t('js.creditCards.creditCardForm.billingAddress')}
        {...this.props}
      >
        {this.props.children}
      </AddressFields>
    );
  }
}

export default BillingAddressFields;



// WEBPACK FOOTER //
// ./javascripts/components/addresses/billing_address_fields.jsx